import React from 'react';
import PropTypes from 'prop-types';
import { StyledDivider } from './styled';

const Divider = ({ orientation, offset, flexItem, customStyle }) => {
    return (
        <StyledDivider
            orientation={orientation}
            offset={offset}
            flexItem={flexItem}
            customStyle={customStyle}
        />
    )
};

Divider.propTypes = {
    orientation: PropTypes.oneOf(['horizontal', 'vertical']),
    offset: PropTypes.number,
    flexItem: PropTypes.bool,
    customStyle: PropTypes.array
};

Divider.defaultProps = {
    orientation: 'horizontal',
    offset: 0,
    flexItem: false
};

export default React.memo(Divider);
